// Phase 7.1 — Tasks label + colour maps.
// Pattern mirrors `frontend/src/pages/CallIntelligence/constants.js`.

export const TASK_PRIORITY_COLORS = {
  urgent: 'bg-rose-100 text-rose-800',
  high:   'bg-orange-100 text-orange-800',
  medium: 'bg-amber-100 text-amber-800',
  low:    'bg-slate-100 text-slate-700',
};

export const TASK_STATUS_COLORS = {
  open:        'bg-sky-100 text-sky-800',
  in_progress: 'bg-indigo-100 text-indigo-800',
  completed:   'bg-emerald-100 text-emerald-800',
  dismissed:   'bg-slate-100 text-slate-700',
};

export const TASK_TYPE_LABELS = {
  callback:            'Callback',
  follow_up:           'Follow-up',
  manager_review:      'Manager review',
  finance_follow_up:   'Finance follow-up',
  trade_follow_up:     'Trade follow-up',
  qa_review:           'QA review',
};

export const TASK_PRIORITY_LABELS = {
  urgent: 'Urgent',
  high:   'High',
  medium: 'Medium',
  low:    'Low',
};

export const TASK_STATUS_LABELS = {
  open:        'Open',
  in_progress: 'In progress',
  completed:   'Completed',
  dismissed:   'Dismissed',
};

export const TASK_SOURCE_LABELS = {
  call_intelligence: 'AI analysis',
  manual:            'Manual',
  system:            'System',
};
